import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  // 1-1
  compColumns1: [
    {
      label: '时间',
      prop: 'dateTime'
    },
    {
      label: '数量',
      prop: 'value'
    }
  ],
  // 1-2
  compColumns2: [
    {
      label: '时间',
      prop: 'dateTime'
    },
    {
      label: '比赛名称',
      prop: 'name'
    },
    {
      label: '签位数',
      prop: 'Qnum'
    },
    {
      label: '报名数',
      prop: 'Bnum'
    }
  ],
  // 2-2
  trainColumns2: [
    {
      label: '时间',
      prop: 'dateTime'
    },
    {
      label: '培训名称',
      prop: 'name'
    },
    {
      label: '签位数',
      prop: 'Qnum'
    },
    {
      label: '报名数',
      prop: 'Bnum'
    }
  ],
  // 3-2
  financeColum2: [
    {
      label: '时间',
      prop: 'dateTime'
    },
    {
      label: '金额（元）',
      prop: 'value'
    }
  ],
  // 3-5
  financeColum3: [
    {
      label: '时间',
      prop: 'dateTime'
    },
    {
      label: '名称',
      prop: 'name'
    },
    {
      label: '总金额（元）',
      prop: 'allMoney'
    },
    {
      label: '入账金额（元）',
      prop: 'enterMoney'
    },
    {
      label: '退费金额（元）',
      prop: 'refundMoney'
    }
  ]
}
